import CategoriasTree from "features/Inventario/components/CategoriasTree"
import EditCategoria from "features/Inventario/components/EditCategoriaForm"
import NewCategoriaForm from "features/Inventario/components/NewCategoriaForm"
import useCategorias from "features/Inventario/hooks/useCategorias"
import { useTranslation } from "react-i18next"
import "./categorias.scss"

const Categorias = () => {
  const { t } = useTranslation()
  const {
    categorias,
    fetchingCategorias,
    canEditCategorias,
    handleChangeCategorias,
    handleSelectCategoria,
    handleUpdateCategorias,
  } = useCategorias()

  return (
    <div className='categorias-grid'>
      <div className='text-left'>
        <p className='text-finanway'>{t("categorias.title")}</p>

        <p className='f-18 f-weight-500'>{t("categorias.addCategory")}</p>

        {/* @ts-expect-error TS(2322): Type '{ t: TFunction<"translation", undefined, "tr... */}
        <NewCategoriaForm t={t} />
      </div>

      <CategoriasTree
        loading={fetchingCategorias}
        canEdit={canEditCategorias}
        items={categorias}
        setItems={handleChangeCategorias}
        onMoveItem={handleUpdateCategorias}
        onClick={handleSelectCategoria}
      />

      <EditCategoria />
    </div>
  )
}

export default Categorias
